// GENERATED by scripts/generate-render-variant-color-tokens.js from the compiled render-engine.css.
// Do NOT edit by hand. Re-run after adding/changing variants: build, run the script, build again.
//
// Maps each catalog variant id -> the lobby color token keys its CSS actually uses, so the Render
// Theme editor can surface only the colours of the variants placed in the layout (grouped per
// variant). RenderLobbyPageColorTokens = lobby tokens not scoped to any variant (page chrome).
export var RenderVariantColorTokens = {
    "banners-t1": [
        "lobby-banner-lottery-background",
        "lobby-banner-lottery-details-digits-background",
        "lobby-banner-lottery-details-digits-foreground",
        "lobby-banner-lottery-details-foreground",
        "lobby-banner-lottery-prize-button-background",
        "lobby-banner-lottery-prize-button-foreground",
        "lobby-banner-lottery-prize-button-hover-background",
        "lobby-banner-lottery-prize-button-hover-foreground",
        "lobby-banner-lottery-prize-foreground"
    ],
    "banners-t3": [
        "lobby-banner-lottery-background",
        "lobby-banner-lottery-details-digits-background",
        "lobby-banner-lottery-details-digits-foreground",
        "lobby-banner-lottery-details-foreground",
        "lobby-banner-lottery-prize-button-background",
        "lobby-banner-lottery-prize-button-foreground",
        "lobby-banner-lottery-prize-button-hover-background",
        "lobby-banner-lottery-prize-button-hover-foreground",
        "lobby-banner-lottery-prize-foreground"
    ],
    "banners-t7": [
        "lobby-banner-lottery-background",
        "lobby-banner-lottery-details-digits-background",
        "lobby-banner-lottery-details-digits-foreground",
        "lobby-banner-lottery-details-foreground",
        "lobby-banner-lottery-prize-button-background",
        "lobby-banner-lottery-prize-button-foreground",
        "lobby-banner-lottery-prize-button-hover-background",
        "lobby-banner-lottery-prize-button-hover-foreground",
        "lobby-banner-lottery-prize-foreground"
    ],
    "bundles-t7": [
        "lobby-bundles-background",
        "lobby-bundles-button-background",
        "lobby-bundles-button-background-hover",
        "lobby-bundles-button-foreground",
        "lobby-bundles-button-foreground-hover",
        "lobby-bundles-foreground",
        "lobby-bundles-show-more-foreground",
        "lobby-bundles-title-foreground"
    ],
    "fold-t1": [
        "lobby-fold-background",
        "lobby-fold-jackpot-background",
        "lobby-fold-jackpot-button-background",
        "lobby-fold-jackpot-button-foreground",
        "lobby-fold-jackpot-button-hover-background",
        "lobby-fold-jackpot-button-hover-foreground",
        "lobby-fold-jackpot-next-draw-foreground",
        "lobby-fold-jackpot-prize-foreground"
    ],
    "fold-t7": [
        "lobby-fold-background",
        "lobby-fold-button-subscribe-background",
        "lobby-fold-button-subscribe-background-hover",
        "lobby-fold-button-subscribe-foreground",
        "lobby-fold-button-subscribe-foreground-hover",
        "lobby-fold-jackpot-background",
        "lobby-fold-jackpot-button-background",
        "lobby-fold-jackpot-button-foreground",
        "lobby-fold-jackpot-button-hover-background",
        "lobby-fold-jackpot-button-hover-foreground",
        "lobby-fold-jackpot-prize-foreground",
        "lobby-fold-jackpot-subscribe-foreground",
        "lobby-fold-jackpot-time-remaining-border",
        "lobby-fold-jackpot-time-remaining-foreground"
    ],
    "how-to-play-t3": [
        "lobby-how-to-play-title-foreground"
    ],
    "instant-game-cards-t7": [
        "lobby-instant-game-cards-card-cta-background",
        "lobby-instant-game-cards-card-cta-background-hover",
        "lobby-instant-game-cards-card-cta-foreground",
        "lobby-instant-game-cards-card-cta-foreground-hover",
        "lobby-instant-game-cards-card-details-background",
        "lobby-instant-game-cards-card-price-foreground",
        "lobby-instant-game-cards-card-title-foreground",
        "lobby-instant-game-cards-title"
    ],
    "instant-games-t7": [
        "lobby-instant-games-background",
        "lobby-instant-games-button-background",
        "lobby-instant-games-button-background-hover",
        "lobby-instant-games-button-foreground",
        "lobby-instant-games-button-foreground-hover",
        "lobby-instant-games-title-foreground"
    ],
    "latest-results-t1": [
        "lobby-latest-results-all-results-foreground",
        "lobby-latest-results-button-background",
        "lobby-latest-results-button-foreground",
        "lobby-latest-results-button-hover-background",
        "lobby-latest-results-button-hover-foreground",
        "lobby-latest-results-date-foreground",
        "lobby-latest-results-name-foreground",
        "lobby-latest-results-num-background",
        "lobby-latest-results-num-bonus-background",
        "lobby-latest-results-num-bonus-foreground",
        "lobby-latest-results-num-border",
        "lobby-latest-results-num-foreground",
        "lobby-latest-results-title-foreground"
    ],
    "latest-results-t3": [
        "lobby-latest-results-all-results-foreground",
        "lobby-latest-results-button-background",
        "lobby-latest-results-button-foreground",
        "lobby-latest-results-button-hover-background",
        "lobby-latest-results-button-hover-foreground",
        "lobby-latest-results-date-foreground",
        "lobby-latest-results-name-foreground",
        "lobby-latest-results-num-background",
        "lobby-latest-results-num-bonus-background",
        "lobby-latest-results-num-bonus-foreground",
        "lobby-latest-results-num-border",
        "lobby-latest-results-num-foreground",
        "lobby-latest-results-title-foreground"
    ],
    "latest-results-t7": [
        "lobby-latest-results-all-results-foreground",
        "lobby-latest-results-background",
        "lobby-latest-results-border",
        "lobby-latest-results-button-background",
        "lobby-latest-results-button-foreground",
        "lobby-latest-results-button-hover-background",
        "lobby-latest-results-button-hover-foreground",
        "lobby-latest-results-country-foreground",
        "lobby-latest-results-date-foreground",
        "lobby-latest-results-name-foreground",
        "lobby-latest-results-num-background",
        "lobby-latest-results-num-bonus-background",
        "lobby-latest-results-num-bonus-foreground",
        "lobby-latest-results-num-border",
        "lobby-latest-results-num-foreground",
        "lobby-latest-results-prize-foreground",
        "lobby-latest-results-title-foreground"
    ],
    "lotteries-carousel-t7": [
        "lobby-carousel-lotteries-arrow-icon-background",
        "lobby-carousel-lotteries-arrow-icon-foreground",
        "lobby-carousel-lotteries-lottery-content-background",
        "lobby-carousel-lotteries-lottery-content-name-foreground",
        "lobby-carousel-lotteries-lottery-content-next-draw-foreground",
        "lobby-carousel-lotteries-lottery-content-prize-foreground",
        "lobby-carousel-lotteries-lottery-footer-background",
        "lobby-carousel-lotteries-lottery-footer-button-background",
        "lobby-carousel-lotteries-lottery-footer-button-foreground",
        "lobby-carousel-lotteries-lottery-footer-button-hover-background",
        "lobby-carousel-lotteries-lottery-footer-button-hover-foreground"
    ],
    "lotteries-grid-t1": [
        "lobby-lotteries-lottery-background",
        "lobby-lotteries-lottery-button-background",
        "lobby-lotteries-lottery-button-foreground",
        "lobby-lotteries-lottery-button-hover-background",
        "lobby-lotteries-lottery-button-hover-foreground",
        "lobby-lotteries-lottery-country-foreground",
        "lobby-lotteries-lottery-name-foreground",
        "lobby-lotteries-lottery-next-draw-foreground",
        "lobby-lotteries-lottery-prize-foreground",
        "lobby-lotteries-sub-title",
        "lobby-lotteries-title"
    ],
    "lotteries-grid-t10": [
        "lobby-lotteries-lottery-button-background",
        "lobby-lotteries-lottery-button-foreground",
        "lobby-lotteries-lottery-button-hover-background",
        "lobby-lotteries-lottery-button-hover-foreground",
        "lobby-lotteries-lottery-card-background",
        "lobby-lotteries-lottery-card-content-background",
        "lobby-lotteries-lottery-card-country-foreground",
        "lobby-lotteries-lottery-card-date-foreground",
        "lobby-lotteries-lottery-card-footer-date-foreground",
        "lobby-lotteries-lottery-card-jackpot-amount-foreground",
        "lobby-lotteries-lottery-card-name-foreground",
        "lobby-lotteries-lottery-num-background",
        "lobby-lotteries-lottery-num-bonus-background",
        "lobby-lotteries-lottery-num-bonus-foreground",
        "lobby-lotteries-lottery-num-foreground"
    ],
    "lotteries-grid-t7": [
        "lobby-lotteries-lottery-background",
        "lobby-lotteries-lottery-button-background",
        "lobby-lotteries-lottery-button-foreground",
        "lobby-lotteries-lottery-button-hover-background",
        "lobby-lotteries-lottery-button-hover-foreground",
        "lobby-lotteries-lottery-country-foreground",
        "lobby-lotteries-lottery-name-foreground",
        "lobby-lotteries-lottery-next-draw-foreground",
        "lobby-lotteries-lottery-prize-foreground",
        "lobby-lotteries-show-more-foreground",
        "lobby-lotteries-sub-title",
        "lobby-lotteries-title"
    ],
    "lotteries-grid-t9": [
        "lobby-lotteries-lottery-background",
        "lobby-lotteries-lottery-button-background",
        "lobby-lotteries-lottery-button-foreground",
        "lobby-lotteries-lottery-button-hover-background",
        "lobby-lotteries-lottery-button-hover-foreground",
        "lobby-lotteries-lottery-country-foreground",
        "lobby-lotteries-lottery-name-foreground",
        "lobby-lotteries-lottery-next-draw-foreground",
        "lobby-lotteries-lottery-num-background",
        "lobby-lotteries-lottery-num-bonus-background",
        "lobby-lotteries-lottery-num-bonus-foreground",
        "lobby-lotteries-lottery-num-foreground",
        "lobby-lotteries-lottery-prize-foreground",
        "lobby-lotteries-sub-title",
        "lobby-lotteries-title"
    ],
    "scratch-cards-carousel-t7": [
        "lobby-scratch-cards-carousel-card-price-background",
        "lobby-scratch-cards-carousel-card-price-foreground",
        "lobby-scratch-cards-carousel-card-title-foreground",
        "lobby-scratch-cards-carousel-title"
    ],
    "stories-t7": [
        "lobby-lotteries-stories-closing-background",
        "lobby-lotteries-stories-closing-foreground",
        "lobby-lotteries-stories-jackpot-foreground",
        "lobby-template-background"
    ]
};
export var RenderLobbyPageColorTokens = [
    "lobby-header-background",
    "lobby-header-cart-count-background",
    "lobby-header-cart-count-foreground",
    "lobby-header-navigation-fab-cart-background",
    "lobby-header-navigation-fab-cart-foreground",
    "lobby-header-navigation-nav-background",
    "lobby-header-navigation-nav-background-hover",
    "lobby-header-navigation-nav-divider",
    "lobby-header-navigation-nav-foreground",
    "lobby-header-navigation-nav-foreground-hover",
    "lobby-header-navigation-nav-selected-background",
    "lobby-header-navigation-nav-selected-foreground",
    "lobby-header-purchase-count-background",
    "lobby-header-purchase-count-foreground",
    "lobby-quick-play-background",
    "lobby-quick-play-choose-tickets-add-line-background",
    "lobby-quick-play-choose-tickets-add-line-background-hover",
    "lobby-quick-play-choose-tickets-add-line-foreground",
    "lobby-quick-play-choose-tickets-add-line-foreground-hover",
    "lobby-quick-play-choose-tickets-button-cart-background",
    "lobby-quick-play-choose-tickets-button-cart-foreground",
    "lobby-quick-play-choose-tickets-button-cart-hover-background",
    "lobby-quick-play-choose-tickets-button-cart-hover-foreground",
    "lobby-quick-play-choose-tickets-button-get-background",
    "lobby-quick-play-choose-tickets-button-get-foreground",
    "lobby-quick-play-choose-tickets-button-get-hover-background",
    "lobby-quick-play-choose-tickets-button-get-hover-foreground",
    "lobby-quick-play-choose-tickets-delete-icon-foreground",
    "lobby-quick-play-choose-tickets-discount-label-foreground",
    "lobby-quick-play-choose-tickets-discount-value-foreground",
    "lobby-quick-play-choose-tickets-draw-background",
    "lobby-quick-play-choose-tickets-draw-border",
    "lobby-quick-play-choose-tickets-draw-foreground",
    "lobby-quick-play-choose-tickets-draw-selected-background",
    "lobby-quick-play-choose-tickets-draw-selected-border",
    "lobby-quick-play-choose-tickets-draw-selected-foreground",
    "lobby-quick-play-choose-tickets-draws-background",
    "lobby-quick-play-choose-tickets-draws-label-foreground",
    "lobby-quick-play-choose-tickets-header-date-foreground",
    "lobby-quick-play-choose-tickets-header-prize-foreground",
    "lobby-quick-play-choose-tickets-header-title-foreground",
    "lobby-quick-play-choose-tickets-line-background",
    "lobby-quick-play-choose-tickets-line-draw-border-color",
    "lobby-quick-play-choose-tickets-line-draw-foreground",
    "lobby-quick-play-choose-tickets-line-num-background",
    "lobby-quick-play-choose-tickets-line-num-bonus-background",
    "lobby-quick-play-choose-tickets-line-num-bonus-foreground",
    "lobby-quick-play-choose-tickets-line-num-foreground",
    "lobby-quick-play-choose-tickets-login-message-background",
    "lobby-quick-play-choose-tickets-login-message-foreground",
    "lobby-quick-play-choose-tickets-total-label-foreground",
    "lobby-quick-play-choose-tickets-total-value-foreground",
    "lobby-quick-play-desc-foreground",
    "lobby-quick-play-lotteries-jackpot-foreground",
    "lobby-quick-play-title-foreground",
    "lobby-terms-and-conditions-foreground"
];
